// Paperclip — accent if a receipt is attached, dim ink-5 otherwise.
// Mirrors gastos-v2/primitives.jsx ReceiptIcon.
'use client';

export function ReceiptIcon({
  has,
  size = 14,
}: {
  has: boolean;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke={has ? 'var(--accent)' : 'var(--ink-5)'}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label={has ? 'Comprobante adjunto' : 'Sin comprobante'}
    >
      <path d="M14 7.5l-5.5 5.5a3 3 0 0 1-4.2-4.2l5.5-5.5a2 2 0 0 1 2.8 2.8l-5.5 5.5a1 1 0 0 1-1.4-1.4l5-5" />
    </svg>
  );
}
